/* eslint-disable import/prefer-default-export */
export const PROD_HOST = 'online.cardif.cz';
export const TEST_ATTR = 'data-testid';
